import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "sb-counter",
  templateUrl: "./sb-counter.component.html",
  styleUrls: ["./sb-counter.component.scss"],
  standalone: true,
  imports: [CommonModule],
})
export class SbCounterComponent {
  /**
   * trigger scroll to left when input change
   * @input count
   * @type number || string
   * */
  @Input() count?: number;
  @Output() onClick: EventEmitter<any> = new EventEmitter();

  constructor() {
    this.onClick = new EventEmitter();
  }
}
